import type { FeedbackItem } from "../../../api";
import { formatDateTime } from "../../../utils";
import { FeedbackStatusBadge } from "./FeedbackStatusBadge";

type FeedbackDetailHeaderProps = {
  feedback: FeedbackItem;
};

export function FeedbackDetailHeader({ feedback }: FeedbackDetailHeaderProps) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div>
        <div className="mb-2">
          <FeedbackStatusBadge status={feedback.status} />
        </div>
        <h3 className="text-base font-semibold text-gray-900">
          {feedback.reporter?.full_name ?? "Unknown user"}
        </h3>
        <p className="text-sm text-gray-500">
          {feedback.reporter?.email ?? "No email"} -{" "}
          {formatDateTime(feedback.created_at)}
        </p>
      </div>
      {feedback.resolved_at && (
        <p className="text-right text-xs text-gray-400">
          Resolved by {feedback.resolver?.full_name ?? "unknown"} on{" "}
          {formatDateTime(feedback.resolved_at)}
        </p>
      )}
    </div>
  );
}
